/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { JSXInternal } from 'preact/src/jsx';
import { SinglelineText } from './SinglelineText';

type SVGTextAttrs = JSXInternal.SVGAttributes<SVGTextElement>;

type MultilineTextProps = {
  text: string;
  lines: string[];
  lineProps: SVGTextAttrs[];
  textStyle: SVGTextAttrs['style'];
  isRotated: boolean;
  isRtl: boolean;
  dataProps?: Record<`data-oj-private-${string}`, string | undefined>;
  id?: string;
  class?: string;
  isTruncated?: boolean;
};

export function MultilineText({
  text,
  lines,
  lineProps,
  dataProps,
  id,
  textStyle,
  isRotated,
  isRtl,
  isTruncated,
  ...otherProps
}: MultilineTextProps) {
  return (
    <g {...dataProps} id={id} className={otherProps.class} style={textStyle} aria-label={text}>
      {lines.map((line, i) => {
        return (
          <SinglelineText text={line} props={lineProps[i]} isRotated={isRotated} isRtl={isRtl} />
        );
      })}
    </g>
  );
}
